import capitalize from "lodash/capitalize";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Tab } from "@circle-react-uikit/TabV2";
import { DefaultEditorCategoryContent } from "./DefaultEditorCategoryContent";
import type { TabGroups, TabOnlyGroups } from "./useCategorizedBlockProps";

export interface DefaultEditorTabFieldsProps {
  blockId: string;
  nestedGroups: TabGroups;
  tabCategories: string[] | ReadonlyArray<string>;
  tabOnlyGroups: TabOnlyGroups;
}

export const DefaultEditorTabFields = ({
  blockId,
  tabCategories,
  nestedGroups,
  tabOnlyGroups,
}: DefaultEditorTabFieldsProps) => {
  const hasTwoOrLessTabs = tabCategories.length <= 2;

  return (
    <Tab.Group key={blockId} className="h-auto overflow-hidden">
      <Tab.List
        listClassName={classNames({
          "gap-x-0": !hasTwoOrLessTabs,
        })}
      >
        {tabCategories.map(category => (
          <Tab
            key={category}
            className={classNames({
              "w-full": hasTwoOrLessTabs,
              "px-4": !hasTwoOrLessTabs,
            })}
            wrapperClassName={classNames("first:ml-6 last:mr-6", {
              "w-full": hasTwoOrLessTabs,
            })}
          >
            {t(["builder_ui.block_props_category", category], {
              defaultValue: capitalize(category),
            })}
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels className="border-primary overflow-hidden border-t">
        {tabCategories.map(tabCategory => (
          <Tab.Panel key={tabCategory}>
            <DefaultEditorCategoryContent
              category={tabCategory}
              nestedGroups={nestedGroups}
              tabOnlyGroups={tabOnlyGroups}
            />
          </Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  );
};
